@if(isLoading()) {
  <ngx-skeleton-loader [theme]="{ height: '100%' }" />
} @else {
  <div class="room-state-wrapper">
    <div class="room-state">
      <div class="room-name">{{ room()?.friendlyName }}</div>
      <div class="room-footer">
        <mat-icon fontIcon="group" />
        <span class="people-count">{{ people() }}</span>
      </div>
    </div>
    <div class="metrics-section">
      <div class="metrics-grid">
        <div class="metric-card">
          <div class="metric-label">Temperature</div>
          <div class="metric-value">{{ (temperature() | number:'1.0-0') ?? '-' }}</div>
          <div class="metric-unit">{{ temperatureUnit()?.displayShort ?? temperatureUnit()?.display }}</div>
          <div class="metric-bar"></div>
        </div>

        <div class="metric-card">
          <div class="metric-label">RH</div>
          <div class="metric-value">{{ humidity() ?? '-' }}</div>
          <div class="metric-unit">%</div>
          <div class="metric-bar"></div>
        </div>

        <div class="metric-card">
          <div class="metric-label">CO2</div>
          <div class="metric-value">{{ co2() ?? '-' }}</div>
          <div class="metric-unit">ppm</div>
          <div class="metric-bar"></div>
        </div>

        <div class="metric-card">
          <div class="metric-label">pm2.5</div>
          <div class="metric-value">{{ pm25() ?? '-' }}</div>
          <div class="metric-unit">µg/m³</div>
          <div class="metric-bar"></div>
        </div>

        <div class="metric-card">
          <div class="metric-label">pm10</div>
          <div class="metric-value">{{ pm10() ?? '-' }}</div>
          <div class="metric-unit">µg/m³</div>
          <div class="metric-bar"></div>
        </div>

        <div class="metric-card">
          <div class="metric-label">TVOC</div>
          <div class="metric-value">{{ tvoc() ?? '-' }}</div>
          <div class="metric-unit">ppb</div>
          <div class="metric-bar"></div>
        </div>
      </div>
      <div class="last-update-row">
        <span>Last update:</span>
        <span>Camera — {{ camera()?.latestStreamingTimestamp | avsTimeAgo }}</span>
        <span>Air Monitor — {{ airMonitor()?.latestStreamingTimestamp | avsTimeAgo }}</span>
      </div>
    </div>
  </div>
}
